"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPinHollow(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm10.52179 1.43601 4.04215 4.04215c-.47088.31484-1.02904.4868-1.61393.4868-.06387 0-.12452-.00312-.18516-.00951l-.47521-.05009-.3375.33826-2.24499 2.25-.39139.39226.1251.53982c.06581.28399.09918.5714.09918.85426 0 .8246-.26361 1.61318-.74161 2.26044l-2.22192-2.21815-.44708-.44632-.45169-.45245-2.2182-2.22193c.64726-.47799 1.43583-.7416 2.26044-.7416.28286 0 .57027.03337.85426.09918l.53982.1251.39226-.39139 2.25-2.24499.33799-.33723-.04975-.47486c-.00638-.06084-.00958-.12173-.00958-.18578 0-.58498.17193-1.1431.48682-1.61398m-.02179-1.43601c-.89502.71497-1.46503 1.815-1.46503 3.04999 0 .09997.00507.19501.01502.28998l-2.25 2.24499c-.34503-.07996-.70496-.125-1.08002-.125-1.47998 0-2.81.67004-3.69 1.72504l2.94006 2.945-4.97004 4.96498v.90503h.90497l4.96503-4.97003 2.945 2.94c1.055-.88 1.72504-2.21002 1.72504-3.69 0-.375-.04504-.73499-.125-1.08002l2.24499-2.25c.09497.01001.18995.01502.28998.01502 1.23499 0 2.33496-.57001 3.04999-1.46497l-5.5-5.5z' })));
}
exports.default = SvgPinHollow;
